var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-navbar',{staticClass:"navbar-wrapper",attrs:{"type":"dark","variant":"dark"}},[_c('b-navbar-brand',{staticClass:"navbar-brand",attrs:{"href":"/"}},[(_vm.branding.logo == undefined)?_c('img',{staticClass:"navbar-logo",attrs:{"src":_vm.logo}}):_c('img',{staticClass:"navbar-logo",attrs:{"src":_vm.brandlogo}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }